let exchange_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'exchanges', name: 'exchanges.list', component: () => import('./pages/Index.vue') },
      { path: 'exchanges/create', name: 'exchanges.create', component: () => import('./pages/Create.vue') },
      { path: 'exchanges/:id/edit', name: 'exchanges.edit', component: () => import('./pages/Edit.vue') }
    ]
  }
];

export default exchange_routes;
